const doc = [({"en":({"js":({"admin":({"contacts":({"show":({"relations":({"parents":"Parents", "children":"Children"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;